import { getIn, useFormikContext } from 'formik';
import * as React from 'react';

import { TextArea, type TextAreaProps } from '@/design-system/components/ui';

export interface FormikTextAreaProps extends Omit<
  TextAreaProps,
  'error' | 'errorMessage' | 'value' | 'onChange' | 'onBlur'
> {
  name: string;
}

const FormikTextArea = React.forwardRef<HTMLTextAreaElement, FormikTextAreaProps>(({ name, ...props }, ref) => {
  const { values, errors, touched, handleChange, handleBlur } = useFormikContext();

  const value = getIn(values, name) ?? '';
  const error = getIn(errors, name);
  const fieldTouched = getIn(touched, name);
  const errorMessage = fieldTouched && typeof error === 'string' ? error : undefined;

  return (
    <TextArea
      ref={ref}
      name={name}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      error={Boolean(fieldTouched && error)}
      errorMessage={errorMessage}
      {...props}
    />
  );
});

FormikTextArea.displayName = 'FormikTextArea';

export { FormikTextArea };
